import { render, staticRenderFns } from "./LaporanGL.vue?vue&type=template&id=472d9e84&"
import script from "./LaporanGL.vue?vue&type=script&lang=js&"
export * from "./LaporanGL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports